const c = (t = 8) => {
  const n = {};
  for (let e = 0; e <= 20; )
    n[e] = `${t * e}px`, e < 3 ? e += 0.25 : e < 5 ? e += 0.5 : e += 1;
  return n;
}, i = {
  surface: {
    DEFAULT: "#FFFFFF",
    50: "#F8FAFC",
    100: "#F1F5F9",
    200: "#E2E8F0",
    300: "#CBD5E1",
    500: "#FFFFFF"
  },
  onSurface: {
    50: "#F8FAFC",
    100: "#F1F5F9",
    200: "#E2E8F0",
    300: "#CBD5E1",
    400: "#94A3B8",
    500: "#64748B",
    DEFAULT: "#64748B",
    600: "#475569",
    700: "#334155",
    800: "#1E293B",
    900: "#0F172A"
  },
  primary: {
    50: "#EDF0FE",
    100: "#DAE0FD",
    200: "#B5C2FB",
    300: "#90A3FA",
    400: "#6B85F8",
    500: "#4666F6",
    DEFAULT: "#4666F6",
    600: "#3852C5",
    700: "#2A3D94",
    800: "#1C2962",
    900: "#0E1431"
  },
  // @deprecated. use `onSurface` instead.
  secondary: {
    50: "#F8FAFC",
    100: "#F1F5F9",
    200: "#E2E8F0",
    300: "#CBD5E1",
    400: "#94A3B8",
    500: "#64748B",
    DEFAULT: "#64748B",
    600: "#475569",
    700: "#334155",
    800: "#1E293B",
    900: "#0F172A"
  },
  success: {
    50: "#ECF6F4",
    100: "#DAEDE9",
    200: "#AAD6CD",
    300: "#70BAAC",
    400: "#42A491",
    500: "#138D75",
    DEFAULT: "#138D75",
    600: "#0F715E",
    700: "#0B5446",
    800: "#094338",
    900: "#07332A"
  },
  warning: {
    50: "#FDF9EC",
    100: "#FCF3D8",
    200: "#F7E4A6",
    300: "#F2D16A",
    400: "#EEC239",
    500: "#EAB308",
    DEFAULT: "#EAB308",
    600: "#BB8F06",
    700: "#8B6B05",
    800: "#705604",
    900: "#544103"
  },
  critical: {
    50: "#FBF0F0",
    100: "#F7E1E1",
    200: "#EDB9B9",
    300: "#E18A8A",
    400: "#D86565",
    500: "#CE3E3E",
    DEFAULT: "#CE3E3E",
    600: "#A53232",
    700: "#7B2525",
    800: "#631E1E",
    900: "#4A1616"
  },
  interactive: {
    50: "#EFF6FF",
    100: "#DBEAFE",
    200: "#BFDBFE",
    300: "#93C5FD",
    400: "#60A5FA",
    500: "#3B82F6",
    DEFAULT: "#3B82F6",
    600: "#2563EB",
    700: "#1D4ED8",
    800: "#1E40AF",
    900: "#1E3A8A"
  },
  // @deprecated. use `interactive` instead.
  highlight: {
    50: "#EFF6FF",
    100: "#DBEAFE",
    200: "#BFDBFE",
    300: "#93C5FD",
    400: "#60A5FA",
    500: "#3B82F6",
    DEFAULT: "#3B82F6",
    600: "#2563EB",
    700: "#1D4ED8",
    800: "#1E40AF",
    900: "#1E3A8A"
  },
  decorative: {
    one: {
      50: "#FCF6EE",
      100: "#E5A256",
      200: "#533A1F"
    },
    two: {
      50: "#F5F2F8",
      100: "#9A7BBA",
      200: "#382C43"
    },
    three: {
      50: "#E5F6F6",
      100: "#49B7CC",
      200: "#1A424A"
    },
    four: {
      50: "#F5F8EF",
      100: "#97BC62",
      200: "#364423"
    }
  },
  white: {
    200: "#FFFAF0",
    300: "#FFFAFA",
    400: "#FEFEFA",
    500: "#FFFFFF",
    DEFAULT: "#FFFFFF",
    600: "#F5F5F5",
    700: "#F8F8FF"
  },
  black: {
    200: "#171717",
    300: "#141414",
    400: "#0f0f0f",
    500: "#0a0a0a",
    DEFAULT: "#000000",
    600: "#080808",
    700: "#000000"
  },
  common: {
    white: {
      200: "#FFFAF0",
      300: "#FFFAFA",
      400: "#FEFEFA",
      500: "#FFFFFF",
      DEFAULT: "#FFFFFF",
      600: "#F5F5F5",
      700: "#F8F8FF"
    },
    black: {
      200: "#171717",
      300: "#141414",
      400: "#0f0f0f",
      500: "#0a0a0a",
      DEFAULT: "#000000",
      600: "#080808",
      700: "#000000"
    }
  }
}, F = {
  normal: "400",
  medium: "500",
  semibold: "600",
  bold: "700"
}, o = {
  largeTitle: [
    "56px",
    {
      fontWeight: 700,
      lineHeight: "68px",
      letterSpacing: "-0.02rem"
    }
  ],
  largeTitleMobile: [
    "34px",
    {
      fontWeight: 700,
      lineHeight: "41px",
      letterSpacing: "-0.02em"
    }
  ],
  title1: [
    "40px",
    {
      fontWeight: 700,
      lineHeight: "48px",
      letterSpacing: "-0.02em"
    }
  ],
  title1Mobile: [
    "28px",
    {
      fontWeight: 700,
      lineHeight: "34px",
      letterSpacing: "-0.02em"
    }
  ],
  title2: [
    "24px",
    {
      fontWeight: 700,
      lineHeight: "29px",
      letterSpacing: "-0.02em"
    }
  ],
  title2Mobile: [
    "22px",
    {
      fontWeight: 700,
      lineHeight: "27px",
      letterSpacing: "-0.02em"
    }
  ],
  title3: [
    "20px",
    {
      fontWeight: 700,
      lineHeight: "24px",
      letterSpacing: "-0.02em"
    }
  ],
  title3Mobile: [
    "18px",
    {
      fontWeight: 700,
      lineHeight: "22px",
      letterSpacing: "-0.02em"
    }
  ],
  title4: [
    "16px",
    {
      fontWeight: 700,
      lineHeight: "19px",
      letterSpacing: "-0.02em"
    }
  ],
  subtitle1: [
    "24px",
    {
      fontWeight: 500,
      lineHeight: "29px",
      letterSpacing: "-0.02em"
    }
  ],
  subtitle1Mobile: [
    "17px",
    {
      fontWeight: 500,
      lineHeight: "21px",
      letterSpacing: "-0.02em"
    }
  ],
  subtitle2: [
    "16px",
    {
      fontWeight: 600,
      lineHeight: "19px",
      letterSpacing: "0em"
    }
  ],
  subtitle2Mobile: [
    "15px",
    {
      fontWeight: 600,
      lineHeight: "18px",
      letterSpacing: "0em"
    }
  ],
  largeBody: [
    "18px",
    {
      fontWeight: 500,
      lineHeight: "23px",
      letterSpacing: "-0.02em"
    }
  ],
  body: [
    "16px",
    {
      fontWeight: 400,
      lineHeight: "21px",
      letterSpacing: "0em"
    }
  ],
  strong: [
    "16px",
    {
      fontWeight: 600,
      lineHeight: "21px",
      letterSpacing: "0em"
    }
  ],
  smallBody: [
    "14px",
    {
      fontWeight: 400,
      lineHeight: "18px",
      letterSpacing: "0em"
    }
  ],
  strongSmallBody: [
    "14px",
    {
      fontWeight: 600,
      lineHeight: "18px",
      letterSpacing: "0em"
    }
  ],
  button: [
    "15px",
    {
      fontWeight: 500,
      lineHeight: "20px",
      letterSpacing: "0em"
    }
  ],
  preTitle: [
    "12px",
    {
      fontWeight: 600,
      lineHeight: "15px",
      letterSpacing: "0.1em"
    }
  ],
  preTitleMobile: [
    "13px",
    {
      fontWeight: 600,
      lineHeight: "16px",
      letterSpacing: "0.1em"
    }
  ]
}, a = {
  "accordion-down": {
    from: { height: "0" },
    to: { height: "var(--radix-accordion-content-height)" }
  },
  "accordion-up": {
    from: { height: "var(--radix-accordion-content-height)" },
    to: { height: "0" }
  },
  dot: {
    "0%": {
      backgroundColor: "#F8FAFC",
      transform: "scale(1)"
    },
    "50%": {
      backgroundColor: "#CBD5E1",
      transform: "scale(1.3)"
    },
    "100%": {
      backgroundColor: "#F8FAFC",
      transform: "scale(1)"
    }
  },
  "caret-blink": {
    "0%,70%,100%": { opacity: "1" },
    "20%,50%": { opacity: "0" }
  },
  "linear-progress-animation": {
    "0%": { transform: " translateX(0) scaleX(0)" },
    "40%": { transform: "translateX(0) scaleX(0.4)" },
    "100%": { transform: "translateX(100%) scaleX(0.5)" }
  }
}, l = {
  "accordion-down": "accordion-down 0.2s ease-out",
  "accordion-up": "accordion-up 0.2s ease-out",
  "dot-animation": "dot 1s ease-in-out infinite",
  "caret-blink": "caret-blink 1.25s ease-out infinite",
  "linear-progress": "linear-progress-animation 1s infinite linear"
}, r = {
  tooltip: "110",
  navbar: "130",
  dialog: "140",
  sheet: "140",
  select: "150",
  popover: "150",
  dropdown: "150"
}, p = {
  // xs: "0px",
  sm: "600px",
  md: "960px",
  lg: "1280px",
  xl: "1920px"
}, E = {
  fontWeight: F,
  fontSize: o,
  colors: {
    background: i.surface[500],
    muted: i.onSurface[500],
    ...i
  },
  keyframes: a,
  animation: l,
  screens: p,
  zIndex: r
}, s = () => function({ addUtilities: t }) {
  t({
    ".placebo-container": {
      "margin-left": "auto",
      "margin-right": "auto",
      "min-width": "auto",
      display: "flex",
      "justify-content": "center",
      "max-width": "1680px",
      "padding-left": "16px",
      "padding-right": "16px",
      "@screen sm": {
        "padding-left": "40px",
        "padding-right": "40px"
      },
      "@screen md": {
        "padding-left": "200px",
        "padding-right": "200px"
      },
      "@screen xl": {
        "padding-left": "0",
        "padding-right": "0",
        "max-width": "calc(1680px - 200px * 2)"
      }
    },
    ".placebo-container-w-full": {
      display: "block",
      width: "100%",
      "min-width": "100%",
      padding: "0"
    }
  });
};
export {
  o as fontSize,
  F as fontWeight,
  c as generateSpacing,
  i as placeboColors,
  s as placeboPlugin,
  p as screens,
  E as theme,
  r as zIndex
};
